import axios from 'axios'
import config from './config'
import router from '../router'
import { message } from 'ant-design-vue'

// 创建 axios 实例
const instance = axios.create({
  baseURL: config.apiUrl,
  timeout: 30000,
  withCredentials: true, // 允许携带凭证
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
});

// 请求拦截器
instance.interceptors.request.use(
  config => {
    let token = sessionStorage.getItem("token");
    if (token) {
      config.headers.token = token;
    }
    
    // 处理 OPTIONS 预检请求
    if (config.method === 'options') {
      config.headers['Access-Control-Request-Method'] = 'POST, GET, PUT, DELETE';
      config.headers['Access-Control-Request-Headers'] = 'Content-Type, Authorization, token';
    }
    
    return config;
  },
  error => {
    console.error('请求拦截器错误:', error);
    if (error.code === 'ECONNABORTED') {
      message.warning({
        content: '服务器连接超时，请检查网络后重试',
        duration: 5,
        key: 'timeout-error'
      });
    }
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  response => {
    if (response.data.Code === 5) {
      sessionStorage.removeItem('token');
      message.error('登录已过期，请重新登录');
      router.push('/login');
      return Promise.reject(new Error('Token expired'));
    }
    
    if (response.data.Code === 2) {
      // message.error(response.data.Message || '查询失败');
    }
    
    return response;
  },
  async error => {
    // 处理跨域错误
    if (error.message.includes('CORS')) {
      message.error('跨域请求被拒绝，请联系管理员');
      return Promise.reject(error);
    }
    // 网络错误处理
   if (error.code === 'ERR_NETWORK') {
       // 检查是否已经重试过（避免无限重试）
      if (!error.config._retry) {
        error.config._retry = true;
        console.log('网络错误，正在重试...');
        
        try {
          // 等待1秒后重试
          await new Promise(resolve => setTimeout(resolve, 1000));
          const response = await instance.request(error.config);
          console.log('重试成功');
          return response;
        } catch (retryError) {
          console.error('重试失败:', retryError);
          message.error('网络连接失败，请检查网络连接');
          return Promise.reject(retryError);
        }
      } else {
        // 已经重试过了，直接报错
        message.error('网络连接失败，请检查网络连接');
      }
    } else if (error.code === 'ERR_CONNECTION_RESET') {
      message.error('服务器连接被重置，请稍后重试');
    } else if (error.code === 'ECONNABORTED') {
      message.error('请求超时，请稍后重试');
    } else if (error.response) {
      const { status } = error.response;
      const errorMessages = {
        400: '请求参数错误',
        401: '未授权，请登录',
        403: '拒绝访问',
        404: '请求地址不存在',
        500: '服务器内部错误',
        502: '网关错误',
        503: '服务不可用',
        504: '网关超时'
      };
      
      message.error(errorMessages[status] || `请求失败 (${status})`);
    } else {
      message.error('网络连接失败，请检查网络');
    }
    
    return Promise.reject(error);
  }
);

export function get(url, param) {
  return new Promise((resolve, reject) => {
    instance.get(url, { params: param })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function post(url, param, headers) {
  return new Promise((resolve, reject) => {
    instance.post(url, param, {
      headers: headers || { 'Content-Type': 'application/json' }
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}